import validate from "/app/node_modules/nuxt/dist/pages/runtime/validate.js";
import embedded_45route_45global from "/app/src/middleware/embeddedRoute.global.ts";
import manifest_45route_45rule from "/app/node_modules/nuxt/dist/app/middleware/route-rules.js";
export const globalMiddleware = [
  validate,
  embedded_45route_45global,
  manifest_45route_45rule
]
export const namedMiddleware = {}